import { MessageCircle, Mail, Ticket, Clock, FileText, Users } from "lucide-react";

export function ContactSupport() {
  return (
    <div className="flex-1 mt-12">
      {/* Section Header */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Still need help?</h2>
        <p className="text-sm text-gray-500 mt-1">Our support team is here for you</p>
      </div>

      {/* Support Options (3 cards) */}
      <div className="grid grid-cols-3 gap-6">
        {/* Live Chat */}
        <div className="bg-white border-2 border-blue-600 rounded-xl p-6 shadow-lg">
          <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mb-4">
            <MessageCircle className="w-7 h-7 text-blue-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Live Chat</h3>
          <p className="text-sm text-gray-600 mb-4">Chat with our support team in real-time</p>
          <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
            <div className="w-2 h-2 rounded-full bg-green-600"></div>
            <span className="font-medium text-green-700">Available now</span>
          </div>
          <button className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
            Start Chat
          </button>
        </div>

        {/* Email Support */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
          <div className="w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center mb-4">
            <Mail className="w-7 h-7 text-purple-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Email Support</h3>
          <p className="text-sm text-gray-600 mb-4">Send us an email, we&apos;ll respond within 24 hours</p>
          <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
            <Clock className="w-4 h-4" />
            <span>Response in ~4 hours</span>
          </div>
          <button className="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors">
            Send Email
          </button>
        </div>

        {/* Submit Ticket */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
          <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mb-4">
            <Ticket className="w-7 h-7 text-green-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Submit Ticket</h3>
          <p className="text-sm text-gray-600 mb-4">Create a support ticket for complex issues</p>
          <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
            <FileText className="w-4 h-4" />
            <span>Track your request</span>
          </div>
          <button className="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors">
            Create Ticket
          </button>
        </div>
      </div>

      {/* Additional Resources */}
      <div className="mt-8 p-6 bg-gray-50 border border-gray-200 rounded-xl">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-semibold text-gray-900 mb-1">Join our Community</h3>
            <p className="text-sm text-gray-600">Connect with other Kustomer users, share tips, and get advice</p>
          </div>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 flex items-center gap-2 transition-colors">
            <Users className="w-4 h-4" />
            Join Community
          </button>
        </div>
      </div>
    </div>
  );
}
